import { Box, type BoxProps } from "@vapordex/uikit";

const Container = ({ children, ...props }: BoxProps) => (
	<Box px={["16px", "24px"]} mx="auto" maxWidth="1200px" {...props}>
		{children}
	</Box>
);

export default Container;
